import { ActionRequest, Notification } from '../types'
import { isActionRequestNotification } from '../utils'
import subscribeEntityNotifications from './subscribeEntityNotifications'

type NotificationHandler = (notification: Notification<ActionRequest>) => void

export default function subscribeActionRequestNotifications(handle: NotificationHandler) {
  subscribeEntityNotifications((notification) => {
    if (isActionRequestNotification(notification)) {
      handle(notification as Notification<ActionRequest>)
    }
  })
}
